export const GOOGLE_MAPS_API_KEY = "AIzaSyCAfR1hKoJhHLGRkUGTAaF7H_hX6dooEL0";
